// extracted by mini-css-extract-plugin
export default {"SelectedContainer":"MobileBottomConfirmation_SelectedContainer__fgiOn","Active":"MobileBottomConfirmation_Active__COVq+"};